export const personalInfo = {
  name: 'Mihkel Kristofer Vajak',
  role: 'Lead Full Stack Developer',
  tagline: 'TypeScript, Node.js, React Specialist | Epic Leading & Architectural Planning',
  location: 'Tallinn, Estonia',
  email: 'mihkel.vajak@gmail.com',
  github: 'https://github.com/MVajak',
  linkedin: 'https://linkedin.com/in/mihkel-kristofer-vajak-a91539164',
  cvPath: '/mihkel_vajak_CV.pdf',
  cvFilename: 'mihkel_vajak_CV.pdf',
  yearsOfExperience: 7,
  projectsCompleted: 20,
};

export const certifications = [
  {
    id: 'java-se-11',
    name: '1Z0-815 - Java SE 11 Programmer I',
    issuer: 'Oracle',
    year: 2019,
  },
  {
    id: 'web-security',
    name: 'Web Application Security',
    issuer: 'Clarified Security',
    year: 2019,
  },
  {
    id: 'padi',
    name: 'PADI Scuba Diver',
    issuer: 'Eesti Sukeldujate Klubi',
    year: 2019,
  },
];

export const achievements = [
  { id: 'entrum', name: 'Entrum', place: '1st Place', year: 2013 },
  {
    id: 'presidential',
    name: 'Presidential Reception',
    place: 'Invited',
    year: 2014,
  },
  { id: 'java-certified', name: 'Oracle Java SE 11 Certified', year: 2019 },
  { id: 'saaremaa-paike', name: 'Saaremaa Päike', place: '1st Place', year: 2013 },
  {
    id: 'opilasleiutajad',
    name: 'Õpilasleiutajate riiklik konkurss',
    place: '3rd Place',
    year: 2014,
  },
  { id: 'ajujaht', name: 'Ajujaht', place: 'Participant', year: 2016 },
  { id: 'garage48', name: 'Garage48', place: 'Participant', year: 2014 },
];

export const languages = [
  { language: 'Estonian', level: 'Native' },
  { language: 'English', level: 'Professional Working' },
];
